<div class="fixed_status_bar">
  <div class="info_box_outer">
    <div class="info_box" style="width: 25% !important">
      <h4>{{ company_name || "N/A" }}</h4>
      <h6>Customer</h6>
    </div>
    <div class="info_box" style="width: 25% !important">
      <h4>{{ site || "N/A" }}</h4>
      <h6>Site</h6>
    </div>
    <div class="info_box" style="width: 25% !important">
      <h4>{{ application || "N/A" }}</h4>
      <h6>Application</h6>
    </div>
    <div class="info_box" style="width: 25% !important">
      <h4>{{ asset_name || "N/A" }}</h4>
      @if(product_type=='cylinder'){
        <h6>Cylinder Name</h6>
      }@else {
        <h6>Powertrain Name</h6>
      }
    </div>
  </div>
</div>
